// See https://docs.mapbox.com/mapbox-gl-js/style-spec/layers/ for more details

import { AreaRating } from 'const/AreaRating';
import { MapZonesOverlay } from 'const/Map/MapZonesOverlay';

const fills = {
  id: MapZonesOverlay.FillLayerId,
  type: 'fill',
  source: MapZonesOverlay.SourceId,
  layout: {},
  paint: {
    'fill-color': [
      'match',
      ['feature-state', 'rating'],
      AreaRating.LIKE,
      '#4caf50', // Green
      AreaRating.DISLIKE,
      '#e91e63', // Red

      'darkgray',
    ],
    'fill-opacity': [
      'case',
      ['boolean', ['feature-state', 'hover'], false],
      0.8,
      0.5,
    ],
  },
};

const borders = {
  id: MapZonesOverlay.BorderLayerId,
  type: 'line',
  source: MapZonesOverlay.SourceId,
  layout: {},
  paint: {
    'line-color': 'black',
    'line-width': 0.5,
  },
};

const labels = {
  id: MapZonesOverlay.LabelLayerId,
  type: 'symbol',
  source: MapZonesOverlay.SourceId,
  layout: {
    'text-field': '{id}',
    'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
    'text-size': 20,
  },
};

export const PreferredAreaLayers = {
  fills,
  borders,
  labels,
};
